class GloboProductCounter {
  constructor() {
    this.debounceTimer = null;
    this.hideTimer = null;
    this.lastCount = null;
    this.itemsPerPage = null;
    this.updateCount = 0;
    this.isHidden = false;
    this.init();
  }

  init() {
    // Initial hide
    this.hideCounterFor2500ms();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.updateCounter());
    } else {
      this.updateCounter();
    }

    this.observeGloboChanges();
    this.observeFilterClicks();
  }

  hideCounterFor2500ms() {
    this.isHidden = true;
    clearTimeout(this.hideTimer);

    const elements = document.querySelectorAll('.gf-summary, .collection-result-count-text, #resultCount');
    elements.forEach(el => {
      if (el) {
        el.style.visibility = 'hidden';
        el.style.opacity = '0';
      }
    });

    this.hideTimer = setTimeout(() => {
      this.isHidden = false;
      this.showCounter();
    }, 2500);
  }

  showCounter() {
    // Logic: If count is 0, we do not show the counter even if timer expires.
    if (this.lastCount === 0) return;

    const elements = document.querySelectorAll('.gf-summary, .collection-result-count-text, #resultCount');
    elements.forEach(el => {
      if (el) {
        el.style.visibility = 'visible';
        el.style.opacity = '1';
      }
    });
  }

  updateCounter() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      const visibleProducts = this.countVisibleProducts();
      this.updateCounterText(visibleProducts);
    }, 50);
  }

  countVisibleProducts() {
    const productCards = document.querySelectorAll('.grid__item .card-wrapper');
    return productCards.length;
  }

  updateCounterText(visibleCount) {
    this.updateCount++;

    const counterElement = document.querySelector('.gf-summary');

    if (counterElement) {
      const currentText = counterElement.innerText;
      const match = currentText.match(/(\d+)/);
      let globoTotal = 0;
      if (match) {
        globoTotal = parseInt(match[0], 10);
      }

      const hasPagination = document.querySelector('.pagination, .gf-pagination') !== null;
      const ratio = visibleCount > 0 ? globoTotal / visibleCount : 1;

      let finalCount;

      if (hasPagination) {
        if (ratio >= 0.9 && ratio <= 1.1) {
          const paginationLinks = document.querySelectorAll('.gf-pagination a, .pagination a');
          let totalPages = 1;
          paginationLinks.forEach(link => {
            const pageNum = parseInt(link.textContent);
            if (!isNaN(pageNum) && pageNum > totalPages) {
              totalPages = pageNum;
            }
          });
          finalCount = visibleCount * totalPages;
        } else {
          finalCount = globoTotal;
        }
      } else {
        finalCount = visibleCount;
      }

      this.lastCount = finalCount;

      // If final count is 0, hide elements immediately
      if (finalCount === 0) {
        counterElement.style.visibility = 'hidden';
        counterElement.style.opacity = '0';

        const resultCountElement = document.getElementById("resultCount");
        if (resultCountElement) {
          resultCountElement.style.visibility = 'hidden';
          resultCountElement.style.opacity = '0';
        }
        return;
      }

      // Update Text
      const productWord = finalCount === 1 ? 'Product' : 'Products';
      counterElement.innerHTML = `<b>${finalCount}</b> ${productWord}`;

      const resultCountElement = document.getElementById("resultCount");
      if (resultCountElement) {
        resultCountElement.innerHTML = finalCount;
      }

      // If we are NOT in the forced hidden period, show the counter now that we have valid data
      if (!this.isHidden) {
        this.showCounter();
      }
    }
  }

  observeFilterClicks() {
    document.addEventListener('click', (e) => {
      const filterBtn = e.target.closest('button[role="checkbox"], .gf-filter-item, .gf-option, [data-filter]');
      if (filterBtn) {
        this.hideCounterFor2500ms();
      }
    });

    document.addEventListener('globo.filter.updated', () => {
      this.hideCounterFor2500ms();
    });
  }

  observeGloboChanges() {
    const productGrid = document.querySelector('.collection') ||
      document.querySelector('[class*="product-grid"]') ||
      document.querySelector('.grid');

    if (productGrid) {
      const observer = new MutationObserver(() => {
        this.updateCounter();
      });

      observer.observe(productGrid, {
        childList: true,
        subtree: true
      });
    }
  }
}

new GloboProductCounter();
